export const validateLocation = (location: string) => {
  if (!location.match(/^[DJ]-[0-9]{2}-[0-9]{2}-[1-3]\/[1-4]$/)) {
    return false;
  }
  let tmp = location.split("-");
  let magazyn = tmp[0];
  let alejka = Number(tmp[1]);
  let regal = Number(tmp[2]);
  tmp = tmp[3].split("/");
  let x = Number(tmp[0]);
  let y = Number(tmp[1]);
  if (magazyn === "D") {
    if (!(alejka >= 1 && alejka <= 5)) return false;
    if (!(regal >= 1 && regal <= 19)) return false;
    if (!(x >= 1 && x <= 3)) return false;
    if (!(y >= 1 && y <= 4)) return false;
    if (alejka === 1) {
      if (regal === 2 && x > 2) return false;
      if (regal === 19 && x > 2) return false;
    }
    if (alejka === 2) {
      if (regal === 1 && x > 2) return false;
      if (regal === 18 && x > 2) return false;
      if (regal === 19) return false;
    }
    if (alejka === 3) {
      if (regal === 1 && x > 2) return false;
      if (regal === 19) return false;
    }
    if (alejka === 4) {
      if (regal === 19) return false;
      if (y > 3) return false;
    }
    if (alejka === 5) {
      if (regal > 5) return false;
      if (y > 2) return false;
    }
  }
  if (magazyn === "J") {
    if (!(alejka >= 1 && alejka <= 5)) return false;
    if (!(regal >= 1 && regal <= 17)) return false;
    if (!(x >= 1 && x <= 3)) return false;
    if (!(y >= 1 && y <= 3)) return false;
    if (alejka >= 1 && alejka <= 3) {
      if (regal > 16) return false;
    }
    if (alejka === 4) {
      if (regal > 17) return false;
    }
    if (alejka >= 1 && alejka <= 4) {
      if (regal === 1 && x > 2) return false;
      if (regal === 16 && x > 2) return false;
      if (y > 2) return false;
    }
    if (alejka === 5) {
      if (regal > 4) return false;
      if (regal >= 1 && regal <= 2 && y > 2) return false;
      if (regal >= 3 && regal <= 4 && y > 3) return false;
    }
  }
  return true;
};

export const validateEan = (ean: string) => {
  // COFNAC GDY BEDA EANY STALEJ DLUGOSCI
  return /^[0-9]{4,13}$/.test(ean.trim());
};
